import {
    type FC
} from "react";
import type IDropdownMenuSeparatorProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuSeparator: FC<IDropdownMenuSeparatorProps> = ({
    customTheme: customThemeProp,
    style
}) => {
    const context = useDropdownMenuContext({
        part: "Separator"
    });

    return <PopoverSurface.Separator
        customTheme={customThemeProp ?? context?.customTheme}
        style={style}
    />;
};
export default DropdownMenuSeparator;
